/**
 * Whether a policy came from a shopped quote. Saved funding-source details load back as text, and this
 * flag's label has no is/has prefix, so a loaded policy carries 'true' or 'false' (a string, and
 * 'false' is truthy). Only `true` and 'true' count.
 */
export function isAddedViaShopInsurance(
  policy: Pick<PolicyFundingSource, 'addedViaShopInsurance'> | null | undefined,
): boolean {
  const flag: unknown = policy?.addedViaShopInsurance;
  return flag === true || flag === 'true';
}
